"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var clone = require('clone');

var tv4 = require('tv4');

var AcuteToxicity = /*#__PURE__*/function () {
  function AcuteToxicity(opt) {
    _classCallCheck(this, AcuteToxicity);

    this.type = null;
    this.value = null;
    this.unit = null;
    this.animal = null;
    this.route = null;
    this.duration = {
      value: null,
      unit: null
    };

    if (opt) {
      this.fillObject(clone(opt));
    }
  }

  _createClass(AcuteToxicity, [{
    key: "fillObject",
    value: function fillObject(opt) {
      var _this = this;

      Object.keys(this).forEach(function (prop) {
        _this[prop] = opt[prop] !== undefined ? opt[prop] : null;
      });
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, AcuteToxicity.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'acute-toxicity.schema.json',
        type: 'object',
        properties: {
          type: {
            type: ['string', 'null']
          },
          value: {
            type: ['string', 'null']
          },
          unit: {
            type: ['string', 'null']
          },
          animal: {
            type: ['string', 'null']
          },
          duration: {
            type: ['object', 'null']
          },
          route: {
            type: ['string', 'null']
          }
        },
        required: Object.keys(this)
      };
    }
  }]);

  return AcuteToxicity;
}();

module.exports = AcuteToxicity;